import { success, error, warning, info, removeAll } from 'react-notification-system-redux';

export function throwErrorMessage(errorOptions){
    return (dispatch) => {
        if(!errorOptions.autoDismiss)
            errorOptions.autoDismiss = 10;

        if(errorOptions.errorObject && errorOptions.errorObject.noNetworkError){
            errorOptions.uid = errorOptions.errorObject.errorCode;
            errorOptions.message = "Appareil hors connexion";
            dispatch(error(errorOptions));
            return;
        }

        dispatch(error(errorOptions));
    }
}

export function throwSuccessMessage(successOptions){
    return (dispatch) => {
        if(!successOptions.autoDismiss)
            successOptions.autoDismiss = 5;

        dispatch(success(successOptions));
    }
}

export function throwWarning(warningOptions){
    return (dispatch) => {
        if(!warningOptions.autoDismiss)
            warningOptions.autoDismiss = 5;

        dispatch(warning(warningOptions));
    }
}

export function throwInfo(infoOptions){
    return (dispatch) => {
        if(!infoOptions.autoDismiss && infoOptions.autoDismiss !== 0)
            infoOptions.autoDismiss = 5;

        dispatch(info(infoOptions));
    }
}

export function removeAllNotifications(){
    return (dispatch) => {
        dispatch(removeAll());
    }
}

//Gestion d'exceptions provenant du serveur (OpenErp)
export function throwErrorWithGenericExternalBusinessError(errorObject, commonMessage){
    return (dispatch) => {
        let message = commonMessage

        if(errorObject.message && errorObject.type)
            message = errorObject.message;

        dispatch(throwErrorMessage({
            errorObject: errorObject,
            title: "Erreur",
            message: message,
        }));
    }
}
